import { render, staticRenderFns } from "./comDtoContent1.vue?vue&type=template&id=6f6e7339&scoped=true&"
import script from "./comDtoContent1.vue?vue&type=script&lang=js&"
export * from "./comDtoContent1.vue?vue&type=script&lang=js&"
import style0 from "./comDtoContent1.vue?vue&type=style&index=0&id=6f6e7339&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6e7339",
  null
  
)

export default component.exports